import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth.store";

const NotFound = () => {
	const navigate = useNavigate();
	const isAuthenticated = !!useAuthStore((state) => state.accessToken);

	const handleRedirect = () => {
		if (isAuthenticated) {
			navigate("/admin/brands", { replace: true });
		} else {
			navigate("/login", { replace: true });
		}
	};

	return (
		<div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
			<div className="max-w-lg w-full text-center">
				<div className="mb-8">
					<h1 className="text-9xl font-bold text-blue-500">404</h1>
					<div className="mt-4 flex justify-center">
						<svg
							className="h-16 w-16 text-orange-400"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							aria-labelledby="notFoundIcon"
							role="img"
						>
							<title>Page Not Found Icon</title>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
							/>
						</svg>
					</div>
				</div>
				<h2 className="mb-4 text-3xl font-semibold text-gray-800">
					Oops! Page Not Found
				</h2>
				<p className="mb-8 text-gray-600">
					The page you're looking for doesn't exist or has been moved.
				</p>
				<button
					type="button"
					onClick={handleRedirect}
					className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-fynxt hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
				>
					{isAuthenticated ? "Back to Home" : "Go to Login"}
					<svg
						className="ml-2 h-5 w-5"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						aria-labelledby="arrowIcon"
						role="img"
					>
						<title>Arrow Right Icon</title>
						<path
							fillRule="evenodd"
							d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
							clipRule="evenodd"
						/>
					</svg>
				</button>
			</div>
		</div>
	);
};

export default NotFound;
